import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 5px 0 50px 20px;
    width: 555px;
`;

export const CardANS = styled.div`
    background-color: #000000;
    color: #FFFFFF;
    font-size: ${theme.font.size6};
    width: 60px;
    padding: 5px;
`;

export const TextFooter = styled.div`
    font-size: ${theme.font.size10};
    color: #686A6B;
`;

export const AlignItens = styled.div`
    display: flex;
`;
